<div class="h3 m-2">Subscriptions</div>
<app-subscription-dashboard-view></app-subscription-dashboard-view>
<app-subscription-list></app-subscription-list>
